import { getClient } from "./utilities";

const PopupSignup = {
  popup: document.querySelector('[data-popup-signup]'),
  popup_close: document.querySelectorAll('[data-popup-signup-close]'),

  init: async function () {

    // verify elements
    if (this.popup && this.popup_close) {

      // verify client data
      let client = await getClient();
      console.log('client', client);

      // verify local storage
      if (client && !client.phone && !localStorage.getItem('popup-signup-closed')) {
  
        // show popup
        const show = () => { 
          if (!this.popup.classList.contains('-active')) this.popup.classList.add('-active');
          window.removeEventListener('mousemove', show);
          window.removeEventListener('scroll', show);
        }
        window.addEventListener('mousemove', show);
        window.addEventListener('scroll', show);
  
        // handle close
        if (this.popup_close.length > 0) this.popup_close.forEach(close => {
          close.addEventListener('click', () => { 
            
            // hide popup
            this.popup.classList.remove('-active');
  
            // set local storage
            localStorage.setItem('popup-signup-closed', true);

          });
        });
      }
    }
  }
}

export default PopupSignup;
